/* Övergripande controller för brädet. */
import React from "react";
import { Container, Row, Col } from 'react-grid-system';
import 'react-flexr/styles.css'

import WritingWord from './Components/WritingWord';
import WordList from './Components/WordList';
import Footer from "./Components/Footer";
import Description from "./Components/Description";
import NewBoard from "./Components/NewBoard";
import Boards from "./Components/Boards";
import Storage from "./Storage";
import BoardHandler from "./BoardHandler";
import Banner from "./Components/Banner";

class GameController extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            cg: {},
        };
        this.clearChilds = [];
        for (let i = 0; i < 12; i++) {
            this.clearChilds.push(React.createRef());
        }
        this.sizes = [12, 11, 10, 9, 8, 7, 6];
    };

    addLetter(letter, centerletter, nr) {
        this.setState({
            pressOrder: [...this.state.pressOrder, nr],
            word: this.state.word + letter,
            centerletter_pressed: (this.state.centerletter_pressed || centerletter) ? true : false
        });
    };

    deleteLetter = (nr_if_last) => {
        let pressOrder = this.state.pressOrder;
        if (pressOrder.length > 0) {
            let nr = pressOrder[pressOrder.length - 1];
            if (nr_if_last >= 0 && nr_if_last !== nr)
                return;
            pressOrder.pop();
            this.setState({
                word: this.state.word.substring(0, this.state.word.length - 1),
                pressOrder: pressOrder,
                centerletter_pressed: this.state.centerletter_pressed && (nr !== 0)
            });
            this.clearChilds[nr].current.clearState();
        }
    };

    resetChilds = () => {
        this.clearChilds.forEach((child) => {
            if (child && child.current)
                child.current.clearState()
        });
    };


    getNextBoard = async (nr, random) => {
        this.setState({
            isLoaded: false,
            error: undefined
        });
        let { result, error } = await BoardHandler.getBoard(nr, random);
        if (result) {
            this.updateCurrentGame({
                letters: [result.center_letter.toUpperCase(), ...result.other_letters.toUpperCase().split("")],
                correct_words: result.correct_words.map(word => word.toUpperCase()),
                failed_words: [],
                found_words: [],
                boardsize: result.length,
                boarddate: result._date
            });
            this.setState({
                isLoaded: true,
                word: ""
            });
        }
        if (error) {
            this.setState({
                isLoaded: true,
                error
            });
            return;
        }
    }

    componentDidMount() {
        this.setState({
            word: "",
            pressOrder: [],
            centerletter_pressed: false,
        });
        let cg = Storage.get("cg");
        if (cg != null) {
            this.updateCurrentGame(cg);
            this.setState({
                isLoaded: true,
            });
        } else {
            this.getNextBoard(9, true);
        }
    }

    submitWord = () => {
        if (this.state.centerletter_pressed) {
            let { found_words, failed_words, correct_words } = this.state.cg;
            if (correct_words.includes(this.state.word)) {
                if (!found_words.includes(this.state.word)) {
                    found_words.push(this.state.word);
                }
                this.setState({ status: 1 });
                setTimeout(() => {
                    this.setState({ status: 0 })
                }, 1200);
            } else {
                if (!failed_words.includes(this.state.word))
                    failed_words.push(this.state.word);
                this.setState({ status: -1 });
                setTimeout(() => {
                    this.setState({ status: 0 })
                }, 1200);
            }

            this.updateCurrentGame({
                ...this.state.cg,
                found_words: found_words,
                failed_words: failed_words,
            });
            this.setState({
                word: "",
                pressOrder: [],
                centerletter_pressed: false,
            });
            this.resetChilds();
        }
        BoardHandler.fillCache(this.sizes);
    };

    updateCurrentGame = (cg) => {
        this.setState({
            cg: cg,
        });
        Storage.set("cg", cg);
    }

    resetBoard = () => {
        this.setState({
            word: "",
            pressOrder: [],
            centerletter_pressed: false,
        });
        this.resetChilds();
    };


    render() {
        if (!this.state.isLoaded) {
            return <>
                <div>Loading...</div>
                <img style={{ animation: `spin 3s linear infinite` }} src={process.env.PUBLIC_URL + '/logo192x192.png'} alt="loading" />
            </>;
        } else {
            let className = '';
            if (this.state.status === -1)
                className = { animation: 'keys_fail 1s linear' };
            if (this.state.status === 1)
                className = { animation: 'keys_correct 1s linear' };
            return (
                <>
                    <div style={{ ...className, width: "18em" }}>
                        <h1 className='logo'>{Boards.names[this.state.cg.boardsize]}</h1>
                        <NewBoard parent={this} sizes={this.sizes} />
                        {this.state.error ?
                            <>
                            </>
                            :
                            <div className='gameboard'>

                                <Boards gameController={this} />
                                <Container fluid style={{ wrap: "nowrap" }}>
                                    <Row>
                                        <Col xs={9}>
                                            <WritingWord
                                                parent={this}
                                                centerletter_pressed={this.state.centerletter_pressed}
                                                word={this.state.word}
                                                onClick={this.submitWord}
                                            />
                                        </Col>
                                        <Col xs={1}>
                                            <button
                                                onClick={() => this.deleteLetter(-1)}

                                                style={{
                                                    color: "white",
                                                    backgroundColor: "IndianRed",
                                                    padding: "10px",
                                                    fontFamily: "Arial",
                                                    fontSize: "1.5em",
                                                    borderRadius: "10px",
                                                    textAlign: "center"
                                                }}>
                                                &lt;
                                            </button>

                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        }
                    </div>
                    {this.state.error ?
                        <>
                            <div>Brädet du söker kan inte hämtas utan kontakt med servern.</div>
                        </>
                        :
                        <>
                            {
                                this.state.cg.found_words.length <= 3 ? <Description /> : <></>
                            }

                            <WordList
                                found_words={this.state.cg.found_words}
                                correct_words={this.state.cg.correct_words}
                                failed_words={this.state.cg.failed_words}
                            />
                        </>
                    }
                    <Footer date={this.state.cg?.boarddate} />
                    <Banner />
                </>);
        }
    }
}

export default GameController;